var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.globalSearchModalIsDisplayed)?_c('GlobalSearch'):_vm._e(),_vm._v(" "),_c('TopMenu'),_vm._v(" "),_c('Nuxt',{staticClass:"bg-white"}),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }